import { QueryLoader } from "@Light/components/app/QueryLoader";
import { useLocation } from "@Light/components/page/account";
import { useLight } from "@Light/services/light";
import {
  useHeaderTitle,
  useHeaderBackNavigate,
} from "@Light/components/page/header/context";
import { useScaffold } from "@Light/scaffold";
import { DocumentList } from "./DocumentList";
import { DocumentsSelector } from "./DocumentsSelector";

export type DocumentsProps = {
  hideBack?: boolean;
};

export const Documents: React.FC<DocumentsProps> = ({ hideBack }) => {
  useHeaderTitle("Documents");
  useHeaderBackNavigate(hideBack ? undefined : "/account/");

  const { useGetAllLocationsDocumentsQuery } = useLight();
  const { uuid } = useLocation();
  const allDocuments = useGetAllLocationsDocumentsQuery({ uuid });

  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;

  const activeDocuments = allDocuments.data?.data.find(
    (docSet) => docSet.is_active,
  );

  const inactiveDocuments = allDocuments.data?.data.filter(
    (docSet) => !docSet.is_active,
  );

  return (
    <PageBody>
      <QueryLoader
        queries={[allDocuments]}
        errorMessage="The documents couldn’t be loaded at this time. Please try again later."
      >
        <div className="pt-2">
          {inactiveDocuments?.length ? (
            <DocumentsSelector />
          ) : (
            <div className="pt-6">
              <DocumentList
                efl={activeDocuments?.efl}
                yrac={activeDocuments?.yrac}
                tos={activeDocuments?.tos}
              />
            </div>
          )}
        </div>
      </QueryLoader>
    </PageBody>
  );
};
